export enum ReleaseType {
  Pickup = 'pickup',
  Delivery = 'delivery',
  Shipped = 'shipped',
}
